import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import ActionsMenu from "./actionMenu";
import Checkbox from "@mui/material/Checkbox";
import dummyImage from "assets/images/userDummy.png";

export default function usersTableData({
  peopleList = [],
  currentPageUsers = [],
  onDelete,
  onToggleBlock,
  onAllowPermission,
  onSelectAll,
  onSelectUser,
  selectedUsers = [],
  key,
}) {
  const User = ({ image, name, contact }) => {
    const imageSource = image ? image : dummyImage;
    return (
      <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDAvatar src={imageSource} alt={name} size="sm" />
        <MDBox ml={2} lineHeight={1}>
          <MDTypography display="block" variant="button" fontWeight="medium">
            {name}
          </MDTypography>
          <MDTypography variant="caption">{contact}</MDTypography>
        </MDBox>
      </MDBox>
    );
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    return date;
  };

  return {
    columns: [
      {
        Header: (
          <Checkbox
            onChange={onSelectAll}
            checked={
              currentPageUsers.length > 0 &&
              currentPageUsers.every((p) => selectedUsers.includes(p.id))
            }
            indeterminate={
              currentPageUsers.some((p) => selectedUsers.includes(p.id)) &&
              !currentPageUsers.every((p) => selectedUsers.includes(p.id))
            }
          />
        ),
        accessor: "select",
        width: "5%",
        align: "center",
      },
      { Header: "User", accessor: "user", width: "45%", align: "left" },
      { Header: "Continent", accessor: "continent", align: "left" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Created At", accessor: "created", align: "center" },
      { Header: "Action", accessor: "action", align: "center" },
    ],

    rows: peopleList.map((person) => ({
      select: <Checkbox checked={person?.hasUploadAccess} onChange={() => onSelectUser(person)} />,
      user: (
        <User
          image={person?.profileImage}
          name={person?.name}
          contact={`${person?.countryCode}${person?.phoneNumber}`}
        />
      ),
      continent: (
        <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
          {person?.continent?.name}
        </MDTypography>
      ),
      status: (
        <MDBox ml={-1}>
          <MDBadge
            badgeContent={person?.isActive ? "Active" : "Blocked"}
            color={person.isActive ? "success" : "dark"}
            variant="gradient"
            size="sm"
          />
        </MDBox>
      ),
      created: (
        <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
          {formatDate(person?.createdAt)}
        </MDTypography>
      ),
      action: (
        <ActionsMenu
          status={person?.isActive}
          onDelete={() => onDelete(person?.id)}
          onToggleBlock={() => onToggleBlock(person?.id, person?.isActive)}
          onAllowPermission={() => onAllowPermission(person?.id, person?.hasUploadAccess)}
        />
      ),
    })),
  };
}
